import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as layoutActions from "../../../actions/layoutActions";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import { throwException } from "../../../actions/exceptionActions";
import ScrollToFirstErrorComponent from "../../common/ScrollToFirstErrorComponent";
import redirector from "../../../util/redirector";

import BevestigingPageHelper from "./BevestigingPageHelper";
import BevestigingForm from "./BevestigingForm";

class BevestigingPage extends ScrollToFirstErrorComponent {
    constructor(props, context) {
        super(props, context, true);

        this.state = {
            model: {
                organisatie: {

                },
                identificatie: {

                },
                sporttak: {

                },
                adres: {

                },
                doelgroep: {

                },
                socialeMedia: {

                },
                andereOpmerking: {

                }
            }
        };

        this.pageHelper = new BevestigingPageHelper(this, redirector);
    }

    componentDidMount = () => {
        super.componentDidMount();
        this.pageHelper.init();
    };

    componentDidUpdate(prevProps) {
        if (this.props.storeModel !== prevProps.storeModel) {
            this.pageHelper.init();
        }
    }

    handleOnGoToFirstTab = () => this.pageHelper.goToFirstTab();
    handleOnDienIn = () => this.pageHelper.dienIn();

    render() {
        const props = this.props;
        const rechtsvormen = props.rechtsvormen;
        const sporttakken = props.sporttakken;
        const doelgroepen = props.doelgroepen;
        return (
            <BevestigingForm
                goToFirstTab={this.handleOnGoToFirstTab}
                onDienIn={this.handleOnDienIn}
                model={this.state.model}
                rechtsvormen={rechtsvormen}
                sporttakken={sporttakken}
                doelgroepen={doelgroepen}
            />
        );
    }
}

BevestigingPage.propTypes = {
    loadLayout: PropTypes.func
};

function mapStateToProps(state, ownProps) {
    return {
        storeModel: state.nieuweSportclubModels,
        rechtsvormen: state.referentie.rechtsvormen,
        sporttakken: state.referentie.sporttakken,
        doelgroepen: state.referentie.doelgroepen
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadNieuweSportclubBevestigingPageLayout, dispatch),
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        throwException: bindActionCreators(throwException, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(BevestigingPage);